/* tslint:disable */
/* eslint-disable */
/**
 * ELEMENTS API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface SharingPermissionPresetPartialUpdate
 */
export interface SharingPermissionPresetPartialUpdate {
    /**
     * 
     * @type {boolean}
     * @memberof SharingPermissionPresetPartialUpdate
     */
    allowRead?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof SharingPermissionPresetPartialUpdate
     */
    allowCreate?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof SharingPermissionPresetPartialUpdate
     */
    allowWriteFs?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof SharingPermissionPresetPartialUpdate
     */
    allowWriteDb?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof SharingPermissionPresetPartialUpdate
     */
    allowProxyDownload?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof SharingPermissionPresetPartialUpdate
     */
    allowOriginalDownload?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof SharingPermissionPresetPartialUpdate
     */
    allowUpload?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof SharingPermissionPresetPartialUpdate
     */
    allowSharing?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof SharingPermissionPresetPartialUpdate
     */
    allowDeleteFs?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof SharingPermissionPresetPartialUpdate
     */
    allowDeleteDb?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof SharingPermissionPresetPartialUpdate
     */
    showTags?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof SharingPermissionPresetPartialUpdate
     */
    showComments?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof SharingPermissionPresetPartialUpdate
     */
    showLocations?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof SharingPermissionPresetPartialUpdate
     */
    showCustomFields?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof SharingPermissionPresetPartialUpdate
     */
    showRatings?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof SharingPermissionPresetPartialUpdate
     */
    showSubclips?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof SharingPermissionPresetPartialUpdate
     */
    showSubtitles?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof SharingPermissionPresetPartialUpdate
     */
    showAiMetadata?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof SharingPermissionPresetPartialUpdate
     */
    showMarkers?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof SharingPermissionPresetPartialUpdate
     */
    showHistory?: boolean;
    /**
     * 
     * @type {string}
     * @memberof SharingPermissionPresetPartialUpdate
     */
    name?: string;
    /**
     * 
     * @type {boolean}
     * @memberof SharingPermissionPresetPartialUpdate
     */
    _default?: boolean;
}

export function SharingPermissionPresetPartialUpdateFromJSON(json: any): SharingPermissionPresetPartialUpdate {
    return SharingPermissionPresetPartialUpdateFromJSONTyped(json, false);
}

export function SharingPermissionPresetPartialUpdateFromJSONTyped(json: any, ignoreDiscriminator: boolean): SharingPermissionPresetPartialUpdate {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'allowRead': !exists(json, 'allow_read') ? undefined : json['allow_read'],
        'allowCreate': !exists(json, 'allow_create') ? undefined : json['allow_create'],
        'allowWriteFs': !exists(json, 'allow_write_fs') ? undefined : json['allow_write_fs'],
        'allowWriteDb': !exists(json, 'allow_write_db') ? undefined : json['allow_write_db'],
        'allowProxyDownload': !exists(json, 'allow_proxy_download') ? undefined : json['allow_proxy_download'],
        'allowOriginalDownload': !exists(json, 'allow_original_download') ? undefined : json['allow_original_download'],
        'allowUpload': !exists(json, 'allow_upload') ? undefined : json['allow_upload'],
        'allowSharing': !exists(json, 'allow_sharing') ? undefined : json['allow_sharing'],
        'allowDeleteFs': !exists(json, 'allow_delete_fs') ? undefined : json['allow_delete_fs'],
        'allowDeleteDb': !exists(json, 'allow_delete_db') ? undefined : json['allow_delete_db'],
        'showTags': !exists(json, 'show_tags') ? undefined : json['show_tags'],
        'showComments': !exists(json, 'show_comments') ? undefined : json['show_comments'],
        'showLocations': !exists(json, 'show_locations') ? undefined : json['show_locations'],
        'showCustomFields': !exists(json, 'show_custom_fields') ? undefined : json['show_custom_fields'],
        'showRatings': !exists(json, 'show_ratings') ? undefined : json['show_ratings'],
        'showSubclips': !exists(json, 'show_subclips') ? undefined : json['show_subclips'],
        'showSubtitles': !exists(json, 'show_subtitles') ? undefined : json['show_subtitles'],
        'showAiMetadata': !exists(json, 'show_ai_metadata') ? undefined : json['show_ai_metadata'],
        'showMarkers': !exists(json, 'show_markers') ? undefined : json['show_markers'],
        'showHistory': !exists(json, 'show_history') ? undefined : json['show_history'],
        'name': !exists(json, 'name') ? undefined : json['name'],
        '_default': !exists(json, 'default') ? undefined : json['default'],
    };
}

export function SharingPermissionPresetPartialUpdateToJSON(value?: SharingPermissionPresetPartialUpdate | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'allow_read': value.allowRead,
        'allow_create': value.allowCreate,
        'allow_write_fs': value.allowWriteFs,
        'allow_write_db': value.allowWriteDb,
        'allow_proxy_download': value.allowProxyDownload,
        'allow_original_download': value.allowOriginalDownload,
        'allow_upload': value.allowUpload,
        'allow_sharing': value.allowSharing,
        'allow_delete_fs': value.allowDeleteFs,
        'allow_delete_db': value.allowDeleteDb,
        'show_tags': value.showTags,
        'show_comments': value.showComments,
        'show_locations': value.showLocations,
        'show_custom_fields': value.showCustomFields,
        'show_ratings': value.showRatings,
        'show_subclips': value.showSubclips,
        'show_subtitles': value.showSubtitles,
        'show_ai_metadata': value.showAiMetadata,
        'show_markers': value.showMarkers,
        'show_history': value.showHistory,
        'name': value.name,
        'default': value._default,
    };
}


